const state = { isMobile: false }

const actions = {
  setMobileAction({ commit }) {
    commit('setMobileMutation')
  },
}

const mutations = {
  setMobileMutation(state) {
    state.isMobile = /Mobi/i.test(window.navigator.userAgent)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
